import { TakeItemCommand } from "../../core/commands/TakeItemCommand";
import { getComponent, hasComponent } from "../../world/Entity";
import type { EntityKind } from "../../world/Entity";
import type { InventoryCategory } from "../../inventory/Inventory";
import type { Interaction } from "../Interaction";

function categoryForKind(kind: EntityKind): InventoryCategory {
  switch (kind) {
    case "artifact":
      return "artifact";
    case "clothing":
      return "clothing";
    case "furniture":
    case "decoration":
      return "decoration";
    default:
      return "misc";
  }
}

export const takeInteraction: Interaction = {
  id: "take",
  label: "Take",
  scope: "scene",
  canExecute: (ctx) => ctx.entity !== undefined && hasComponent(ctx.entity, "collectible"),
  execute: async (ctx) => {
    if (!ctx.entity) return { success: false };
    const collectible = getComponent(ctx.entity, "collectible")!;
    ctx.commands.execute(new TakeItemCommand(ctx.entity.id, categoryForKind(ctx.entity.kind), collectible.stackable));
    ctx.sfx?.play("take");
    return { success: true };
  },
};
